export function updateURL(params: string) {
  if (history.pushState) {
    const baseUrl =
      window.location.protocol +
      '//' +
      window.location.host +
      window.location.pathname
    const newUrl = baseUrl + params
    history.pushState(null, '', newUrl)
  } else {
    console.warn('History API не поддерживается')
  }
}
